import AccessInfo from "./AccessInfo";
export default AccessInfo;
